import {createElement, Component, PropTypes, cloneElement, Children} from 'rlink-react';

import {elementOf} from 'rlink-utils/RlinkPropTypes';
import Tab from 'rlink-tabs/components/Tab';

import Tooltip from 'rlink-tooltips/Tooltip';

import themeable from 'rlink-theme/themeable';

export default class Tabs extends Component {
  render () {
    return (<div className={`${this.props.theme.Tabs}`}>
      <ul className={this.props.theme.TabsListing}>
        {Children.map(this.props.children, tab =>
          tab && <li key={tab.props.name} className={`
            ${this.props.theme.TabItem}
            ${(this.props.currentTab === tab.props.name) ? this.props.theme.Active : ''}
          `}>
            <Tooltip content={tab.props.tooltip}>
              <a onClick={() => this.props.onTabActivate({tabName: tab.props.name})}
                className={`${this.props.theme.Label} ${(this.props.currentTab === tab.props.name) ? this.props.theme.Active : ''}`}>
                {tab.props.label}
              </a>
            </Tooltip>
          </li>)}
      </ul>
      {this.renderTabContents()}
    </div>);
  }

  renderTabContents () {
    return Children.map(this.props.children, child => (
      (child && this.props.currentTab === child.props.name)
      ? cloneElement(child, { ...Tab.theme(this.props) })
      : null
    ));
  }
}

Tabs.propTypes = {
  children: elementOf(Tab),
  currentTab: PropTypes.string,
  onTabActivate: PropTypes.func,
};
Tabs.defaultProps = {
  currentTab: '',
};

themeable(Tabs, {
  classes: [
    'Tabs',
    'TabsListing',
    'TabItem',
    'Active',
    'Label',
  ],
  forwards: [Tab],
});



// WEBPACK FOOTER //
// ./lib/rlink-tabs/components/Tabs.jsx